import { AfterViewInit, Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ValidationHandlerService, TranslatedToastrService, EditComponent, BaseComponent, LanguageService, ListItemModel, CustomValidators, StringListItemModel } from 'lib/Vestra.shared';
import { AdminToVestraUsersMessageModel, AdminToVestraUsersResultModel, CoreService, VestraUserSelectType, VestraUserService } from 'src/app/services/api-services';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom, Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { VestraUserSelectComponent } from '../../../vestra-user/vestra-user-select/vestra-user-select.component';
import { NotificationResultComponent } from '../notification-result/notification-result.component';
@Component({
    selector: 'app-notification-create',
    templateUrl: './notification-create.component.html',
    styleUrls: ['./notification-create.component.scss'],
})
export class NotificationCreateComponent extends BaseComponent implements OnInit, AfterViewInit {
    @ViewChild('actionsRef') actionsRef: TemplateRef<EditComponent>;

    @ViewChild(VestraUserSelectComponent)
    vestraUserSelectComponent: VestraUserSelectComponent;
    public vestraUserSelectType: VestraUserSelectType = VestraUserSelectType.InAppAndPush;
    public mauiAppName = 'vestraapp://'; //Todo: backend oldalról érkezzen


    public notificationTypeList: ListItemModel[] = [];
    public supportedPageTypeList: StringListItemModel[] = [];
    dropdownSettings: any;
    public title: string;
    public form: FormGroup;
    public isLargeScreen: boolean = false;

    private subscription: Subscription;

    constructor(
        protected override validationHandlerService: ValidationHandlerService,
        private translatedToastrService: TranslatedToastrService,
        private translateService: TranslateService,
        protected override modalService: BsModalService,
        private coreService: CoreService,
        protected override spinnerService: NgxSpinnerService,
        protected override languageService: LanguageService,
        private vestraUserService: VestraUserService,
        private responsive: BreakpointObserver
    ) {
        super(spinnerService, modalService, validationHandlerService, translateService, languageService);
    }


    private selectedUserIds: number[] = [];
    public ngAfterViewInit(): void {
        
    }
    public ngOnInit() {
        this.subscription = this.responsive.observe(Breakpoints.WebLandscape).subscribe(result => {
            this.isLargeScreen = false;

            if (result.matches) {
                this.isLargeScreen = true;
            }
        });

        this.getProviderNotificationTypeList();
        this.init();
    }

    public async init() {
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'value',
            textField: 'text',
            itemsShowLimit: 3,
            allowSearchFilter: true,
            defaultOpen: false,
        };

        this.form = new FormGroup({
            subject: new FormControl('', [Validators.required]),
            message: new FormControl('', [Validators.required]),
            notificationTypeList: new FormControl([], [CustomValidators.selectRequired]),
            actionDeepLink: new FormControl(''),
            actionDeepLinkCustomPageSelected: new FormControl(false),
        });
    }
    public changeSelectedUserIds(event: any) {
        this.selectedUserIds = [...event];
    }
    public sendNotification = async (isAllVestraUsersSelected: boolean): Promise<any> => {
        if (this.validationHandlerService.checkFormValid(this.form)) {
            let itemToSave = this.form.getRawValue();
            let notificationType: any = 0;
            if (itemToSave.notificationTypeList.length == 0) {
                this.translatedToastrService.warning('notification.message_choose_notification_type', 'common.warning');
                return;
            }
            for (let type of itemToSave.notificationTypeList) {
                notificationType += type.value;
            }
            if (notificationType !== 2 && itemToSave.message === '') {
                this.translatedToastrService.warning('notification.message_required', 'common.warning');
                return;
            }

            let adminToVestraUsersMessageModel = {} as AdminToVestraUsersMessageModel;

            adminToVestraUsersMessageModel.subject = itemToSave.subject;
            adminToVestraUsersMessageModel.message = itemToSave.message;
            adminToVestraUsersMessageModel.notificationTypeList = itemToSave.notificationTypeList;
            adminToVestraUsersMessageModel.actionDeepLink = itemToSave.actionDeepLink;
            adminToVestraUsersMessageModel.actionDeepLinkCustomPageSelected = itemToSave.actionDeepLinkCustomPageSelected;

            if (isAllVestraUsersSelected) {
                adminToVestraUsersMessageModel.allSelected = true;
            } else {
                adminToVestraUsersMessageModel.allSelected = false;
                adminToVestraUsersMessageModel.receiverVestraUserIds = this.selectedUserIds;
            }
            const isNotSelected: boolean = !adminToVestraUsersMessageModel.allSelected && adminToVestraUsersMessageModel.receiverVestraUserIds.length === 0;
            if (isNotSelected) {
                this.translatedToastrService.warning('common.vestra_user_select_warning', 'common.warning');
                return;
            }

            return this.handleSpinner(
                firstValueFrom(this.vestraUserService.adminSendMessageToVestraUsers(adminToVestraUsersMessageModel as AdminToVestraUsersMessageModel))
                    .then(res => {
                        if (res.isSuccess) {
                            console.log(res)
                            this.showNotificationResult(res.result);
                            //this.form.reset();
                            this.selectedUserIds = [];
                            this.vestraUserSelectComponent.userIds = [];
                            this.vestraUserSelectComponent.refreshDataTable();
                            // $('#deeplinkSelect').prop('selectedIndex', 0);
                        } else {
                            this.translatedToastrService.warning(res.message, 'common.warning');
                        }
                        return Promise.resolve(res);
                    })
                    .catch((err: HttpErrorResponse) => {
                        this.validationHandlerService.handleServerError(err, this.form);
                    })
            );
        }
    };
    public onSelectChange(event: any) {
        const selectElement = event.target as HTMLSelectElement;
        const selectedValue = selectElement.value;

        const selectedText = selectElement.options[selectElement.selectedIndex].text;
        const foundItem = this.supportedPageTypeList.find(x => x.text == selectedText);

        if (selectedValue != '') {
            if (selectElement.selectedIndex > 0) {
                this.form.get('actionDeepLinkCustomPageSelected').setValue(true);
            }
            else
            {
                this.form.get('actionDeepLinkCustomPageSelected').setValue(false);
            }
            if (foundItem.value != null) {
                this.form.get('actionDeepLink').setValue(this.mauiAppName + selectedText + '?' + foundItem.value);
            } else {
                this.form.get('actionDeepLink').setValue(this.mauiAppName + selectedText);
            }
        } else {
            this.form.get('actionDeepLink').setValue('');
        }
    }
    public onSendNotification(type: any) {
        let itemToSave = this.form.getRawValue();

        switch (type) {
            case 1:
                this.openConfirmDialog(itemToSave?.subject, () => this.sendNotification(false), null, 'common.send_confirm_title', 'common.send_confirm_message');
                break;
            case 2:
                this.openConfirmDialog(itemToSave?.subject, () => this.sendNotification(true), null, 'common.send_confirm_title', 'common.send_confirm_message');
                break;
            default:
                break;
        }
    }

    //#region  Private functions
    private getProviderNotificationTypeList() {
        this.handleSpinner(
            firstValueFrom(this.vestraUserService.getVestraUserNotificationAndSupportedPageTypeList())
                .then(res => {
                    this.notificationTypeList = res.result.notificationTypeList;
                    this.supportedPageTypeList = res.result.supportedPageTypeList;
                    this.notificationTypeList = this.notificationTypeList.map(item => {
                        this.translateService.get(item.text).subscribe((translatedText: string) => {
                            item.text = translatedText;
                        });
                        return item;
                    });
                    return Promise.resolve(res);
                })
                .catch((err: HttpErrorResponse) => {
                    this.validationHandlerService.handleServerError(err);
                })
        );
    }
    private showNotificationResult(adminToVestraUsersResultModel: AdminToVestraUsersResultModel)
    {
        if(adminToVestraUsersResultModel)
        {
            let modalOptions: ModalOptions = this.getDefaultModalOptions('notification.result_title', adminToVestraUsersResultModel);
            modalOptions.class = "modal-xl"
            let bsModalRef: BsModalRef = this.modalService.show(NotificationResultComponent, modalOptions);
        }
    }
}
